import { render, staticRenderFns } from "./MenuCategoriesNavigator.vue?vue&type=template&id=1705a34f&scoped=true&"
import script from "./MenuCategoriesNavigator.vue?vue&type=script&lang=ts&"
export * from "./MenuCategoriesNavigator.vue?vue&type=script&lang=ts&"
import style0 from "./MenuCategoriesNavigator.vue?vue&type=style&index=0&id=1705a34f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1705a34f",
  null
  
)

export default component.exports